/** Shared open state so sidebar and empty-server CTA can open one modal. */
export const createLibraryModal = $state({ open: false, serverid: '' as string })
